import { render, staticRenderFns } from "./inWarehouse.vue?vue&type=template&id=4d2f70ce&scoped=true"
import script from "./inWarehouse.vue?vue&type=script&lang=js"
export * from "./inWarehouse.vue?vue&type=script&lang=js"
import style0 from "./inWarehouse.vue?vue&type=style&index=0&id=4d2f70ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f70ce",
  null
  
)

export default component.exports